import React, { useEffect, useState } from "react";
import { Spin, Typography, Modal, Button, Card } from "antd";

import { FONT, USER_STORAGE } from "constants/index";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  createSprint,
  deleteSprint,
  getReviewUserById,
  getSprintUserById,
  putSprint,
} from "services/review/review-service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getPlanningUserById } from "services/planning/planning-service";
import FormUserPlanningDetails from "./planning-drawer-details";
import { getById } from "services/user/user-service";
dayjs.extend(customParseFormat);
const dateFormat = "DD/MM/YYYY";

const PlanClientUser = () => {
  const [loading, setLoading] = useState(true);
  const [imgAvatar, setImgAvatar] = useState("");
  const [dataDrawer, setDataDrawer] = useState({});


  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        const user = {
          id: id,
          img: res.img,
        };
        setDataDrawer(user);
        setLoading(false)

      });
     

    }
  }, []);

 



  return (
    <div className="container-planning-client">
  
      <Spin size="large" spinning={loading}>
        <Card>
          <FormUserPlanningDetails user={dataDrawer} />
        </Card>
      </Spin>
    </div>
  );
};
export default PlanClientUser;
